import { IMonHoc } from "../../../model/respone/category/IMonHoc";
import { IActionTypeBase } from "../IActionTypeBase";

export enum eMonHocActionTypeIds {
    LOAD_START = "MonHoc_LOAD_START",
    LOAD_SUCCESS = "MonHoc_LOAD_SUCCESS",
    LOAD_ERROR = "MonHoc_LOAD_ERROR"
}
export interface IMonHocLoadStart extends IActionTypeBase<eMonHocActionTypeIds.LOAD_START, undefined> { }
export interface IMonHocLoadSuccess extends IActionTypeBase<eMonHocActionTypeIds.LOAD_SUCCESS, IMonHoc[]> { }
export interface IMonHocLoadError extends IActionTypeBase<eMonHocActionTypeIds.LOAD_ERROR, string | undefined> { }

export type IMonHocActionTypes = IMonHocLoadStart | IMonHocLoadSuccess | IMonHocLoadError